import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserRolesService } from './user-roles.service';
import { SnackbarService } from './snackbar.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private userRole: UserRolesService, private snackBar: SnackbarService, private translation: TranslateService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const dataObj = next.data;
      const roles = Object.keys(dataObj).map((key) => dataObj[key]);
      let returnState = false;
      roles.forEach(role => {
        if (this.userRole.isRole(role)) {
          returnState = true;
        }
      });
      if (!returnState) {
      this.snackBar.openSnackBar('You do not have permission to access this page', '', 'warn');
      return false;
      } else {
        return true;
      }
  }
}
